import { Injectable } from '@angular/core';
import { UserScopedStorageService } from '../user-scoped-storage.service';
import { AiGeneratedQueryData } from './ai-search.service';

const STORAGE_KEY = 'ai_search_recents_v1';
const MAX_RECENTS = 5;

export interface AiSearchRecent {
  savedAt: number;
  data: AiGeneratedQueryData;
}

/**
 * The AI-search dialog's own history, surfaced in the nav search dropdown.
 * Separate from the due-diligence recents: that list belongs to the DD page and
 * must not gain the dialog's topic/commodity queries.
 *
 * Stored per-user (UserScopedStorageService) so recents survive logout for the
 * same account but are never shown to a different account on a shared browser.
 * The legacy bare key is purged centrally at startup.
 */
@Injectable({ providedIn: 'root' })
export class AiSearchRecentsService {
  constructor(private userStorage: UserScopedStorageService) {}

  list(): AiSearchRecent[] {
    try {
      const parsed = JSON.parse(this.userStorage.getItem(STORAGE_KEY) ?? '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(
        (entry) => entry?.data?.query && typeof entry?.data?.name === 'string',
      );
    } catch {
      return [];
    }
  }

  add(data: AiGeneratedQueryData): AiSearchRecent[] {
    const rest = this.list().filter(
      (existing) =>
        existing.data.name.toLowerCase() !== data.name.toLowerCase(),
    );
    const next = [{ savedAt: Date.now(), data }, ...rest].slice(0, MAX_RECENTS);
    this.userStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return next;
  }
}
